/**
 * 退款单API
 */

import request from '@/utils/request'

/**
 * 获取退款单列表
 * @param params
 */
export function getRefundList(params) {
  return request({
    url: 'admin/after-sales/refund',
    method: 'get',
    loading: false,
    params
  })
}

/**
 * 获取售后详情
 * @param sn
 */
export function getRefundDetail(sn) {
  return request({
    url: `admin/after-sales/refund/${sn}`,
    method: 'get',
    loading: false
  })
}
/**
 * 大平台审核
 */
export function auditRefund(sn, params) {
  return request({
    url: `admin/after-sales/audits/${sn}`,
    method: 'post',
    data: params
  })
}
/**
 * 平台退款
 * @param sn
 * @param params
 */
export function refundMoney(sn, params) {
  return request({
    url: `admin/after-sales/refunds/${sn}`,
    method: 'post',
    data: params
  })
}

/**
 * 导出Excel
 * @param params
 */
export function exportRefundExcel(params) {
  return request({
    url: 'admin/after-sales/exports/excel',
    method: 'get',
    params
  })
}

/**
 * 查看物流信息
 */
export function getExpressListBySkuIdNew(params) {
  return request({
    url: '/admin/trade/express/getExpressListBySkuIdNew',
    method: 'get',
    params
  })
}

/**
 * 查询快递物流信息
 * @param params
 * @returns {Promise<any>}
 */
export function getLogisticsInfo(params) {
  return request({
    url: `admin/trade/express`,
    method: "get",
    params
  });
}
/**
 * 大平台确认收货
 */
export function confirmReceipt(sn) {
  return request({
    url: `admin/after-sales/stock-ins/${sn}`,
    method: 'post'
  })
}
